import { styled, Switch } from "@mui/material";
import colors from "../styles/colors";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 22,
  padding: 0,
  display: "flex",
  "&:active .MuiSwitch-thumb": {
    width: 18,
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: theme.palette.common.white,
      "& + .MuiSwitch-track": {
        backgroundColor: colors.primary,
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 18,
    height: 18,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 11,
    backgroundColor: "#bdbdbd", // Adjust color for unchecked state
    opacity: 1,
  },
}));

export default CustomSwitch;